export default __webpack_public_path__ + "static/media/resume.0d8252b0.pdf";